import { useLiveQuery } from "dexie-react-hooks";
import { Star } from "lucide-react";
import { CATEGORY_COLORS, de, type Product } from "@ainkauf/core";
import { favorites } from "@/db/repository";

/**
 * Favoriten über der Liste. Ein Tipp legt den Artikel an, ohne Tippen und
 * ohne Nachdenken. Waagerecht scrollbar, damit die Zeile am Telefon nicht
 * umbricht und die Liste nach unten schiebt.
 */
export function FavoritesRow({ onAdd }: { onAdd: (name: string) => Promise<void> }) {
  const products = useLiveQuery(() => favorites(), [], [] as Product[]);
  if (products.length === 0) return null;

  return (
    <div className="-mx-4 overflow-x-auto px-4" data-testid="favorites">
      <ul className="flex w-max gap-2">
        {products.map((product) => {
          const farbe = product.category ? `var(--food-${CATEGORY_COLORS[product.category]})` : "var(--honey)";
          return (
            <li key={product.id}>
              <button
                type="button"
                onClick={() => void onAdd(product.name)}
                aria-label={`${product.name} ${de.items.quickAddPlaceholder}`}
                data-testid="favorite"
                data-name={product.name}
                className="inline-flex min-h-[44px] items-center gap-2 rounded-full px-4 font-semibold text-ink transition-transform active:scale-95"
                style={{ background: `color-mix(in oklab, ${farbe} 14%, #fff)`, boxShadow: "var(--shadow-card)" }}
              >
                <Star size={14} strokeWidth={2.5} className="text-honey" aria-hidden />
                {product.name}
              </button>
            </li>
          );
        })}
      </ul>
    </div>
  );
}
